export default __webpack_public_path__ + "8634e6e243f37073c413a8311392338d.png";